const PRODUCT_FINDER_SEGMENT = 'catalog';
const CHECKOUT_SEGMENT = 'checkout';
const CHECKOUT_SEGMENT_V2 = 'shop/checkout';

const address = {
  path: `/:language/${CHECKOUT_SEGMENT}/address/`,
  name: 'checkout-address',
};

const delivery = {
  path: `/:language/${CHECKOUT_SEGMENT}/delivery/`,
  name: 'checkout-delivery',
};

const review = {
  path: `/:language/${CHECKOUT_SEGMENT}/review/`,
  name: 'checkout-review',
};

const payment = {
  path: `/:language/${CHECKOUT_SEGMENT}/payment/`,
  name: 'checkout-payment',
};

const response = {
  path: `/:language/${CHECKOUT_SEGMENT}/payment-response/`,
  name: 'payment-response',
};

const success = {
  path: `/:language/${CHECKOUT_SEGMENT}/success/:orderNumber/`,
  name: 'checkout-success',
};

const pending = {
  path: `/:language/${CHECKOUT_SEGMENT}/pending/:orderNumber/`,
  name: 'checkout-pending',
};

const productFinder = {
  path: `/:language/${PRODUCT_FINDER_SEGMENT}/:url(.*)*`,
  name: 'product-finder',
};

export const protectedRoutePatterns = [
  `/:language/${CHECKOUT_SEGMENT}`,
  `/:language/${CHECKOUT_SEGMENT_V2}`,
];

export const checkoutRoutes = {
  address,
  delivery,
  review,
  payment,
  response,
  success,
  pending,
};

export const productFinderRoutes = {
  productFinder,
};
